import type { CoordinatePlanePayload } from '@/components/whiteboard-v2/types';

/**
 * Convert natural-language coordinate-plane description into structured payload.
 */
export async function generateCoordinatePlanePayload(
  description: string,
  context?: string,
): Promise<CoordinatePlanePayload> {
  const response = await fetch('/napi/diagram/coordinate-plane/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ description, context }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error || `Coordinate-plane API returned ${response.status}`);
  }

  const data = (await response.json()) as { payload: CoordinatePlanePayload };
  return data.payload;
}
